export const CHECKOUT_URL =
  'https://mega-pack-electronica-para-emprender.impultienda.ar/checkout'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/vXUjGhvSnLyikNAG1Lwtb1/Imagen_de_Codex_28_ago_2026,_17_04_35.png'

export const PRICE = '$19.990'
export const PRICE_FULL = '$51.000'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'confused' as const,
    title: 'Información desordenada',
    desc: 'Pasás horas entre videos, PDFs y tutoriales diferentes, pero no sabés qué estudiar primero ni cómo conectar todo.',
  },
  {
    icon: 'wrench' as const,
    title: 'Mucha teoría, poca práctica',
    desc: 'Entendés algunos conceptos, pero cuando querés armar un circuito o proyecto por tu cuenta aparecen las dudas.',
  },
  {
    icon: 'phone' as const,
    title: 'Sobrecarga de información',
    desc: 'Buscás una respuesta y encontrás diez explicaciones diferentes. Terminás guardando contenido en vez de aplicarlo.',
  },
  {
    icon: 'compass' as const,
    title: 'Falta de dirección',
    desc: 'Querés aprender, mejorar profesionalmente o emprender con Electrónica, pero no tenés un camino claro para pasar del conocimiento a la acción.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'Fundamentos de Electrónica',
    desc: 'La base que necesitás para comprender la Electrónica y avanzar con mayor seguridad.',
  },
  {
    title: 'Componentes y Mediciones',
    desc: 'Aprendé cómo funcionan resistencias, capacitores, diodos, transistores, sensores y otros componentes esenciales.',
  },
  {
    title: 'Circuitos y Práctica',
    desc: 'Entendé cómo se conectan los componentes y empezá a llevar la teoría a aplicaciones concretas.',
  },
  {
    title: 'Proyectos Electrónicos',
    desc: 'Convertí lo aprendido en circuitos y proyectos que te permitan desarrollar experiencia práctica.',
  },
  {
    title: 'Reparación y Diagnóstico',
    desc: 'Aprendé procesos para realizar mediciones, analizar circuitos, detectar problemas y buscar fallas de forma más ordenada.',
  },
  {
    title: 'Electrónica para Emprender',
    desc: 'Descubrí cómo aplicar tus conocimientos en proyectos, reparaciones, servicios, productos y otras oportunidades relacionadas con Electrónica.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: 'Guía de Inicio Rápido',
    desc: 'Una hoja de ruta para saber qué estudiar primero y cómo avanzar por el sistema.',
  },
  {
    title: 'Banco de Proyectos Electrónicos',
    desc: 'Ideas prácticas para que siempre tengas un próximo proyecto en el que aplicar lo aprendido.',
  },
  {
    title: 'Kit de Plantillas Técnicas',
    desc: 'Plantillas para organizar proyectos, componentes, materiales, mediciones y procedimientos.',
  },
  {
    title: 'Guía de Diagnóstico',
    desc: 'Un recurso práctico para ayudarte a analizar problemas y buscar posibles fallas de manera ordenada.',
  },
  {
    title: 'Guía del Emprendedor Electrónico',
    desc: 'Ideas y orientación para empezar a transformar conocimientos técnicos en proyectos, productos o servicios.',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'zap' as const,
    title: 'Más claridad',
    desc: 'Abrí el sistema, seguí el contenido y sabé cuál es el próximo paso sin empezar una búsqueda nueva cada vez.',
  },
  {
    icon: 'wrench' as const,
    title: 'Más práctica',
    desc: 'Dejá de acumular solamente teoría y empezá a conectar componentes, circuitos y proyectos.',
  },
  {
    icon: 'brain' as const,
    title: 'Aprendizaje organizado',
    desc: 'Tené fundamentos, mediciones, circuitos, proyectos y diagnóstico siguiendo una estructura clara.',
  },
  {
    icon: 'rocket' as const,
    title: 'Más posibilidades',
    desc: 'Usá lo aprendido para proyectos propios, desarrollo profesional, docencia o para explorar oportunidades de emprendimiento.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote: 'Me ayudó a ordenar todo y empezar a practicar de verdad.',
    author: 'Carlos M.',
    location: 'Córdoba',
  },
  {
    quote: 'Los proyectos son claros y fáciles de seguir. Muy buen material.',
    author: 'Diego R.',
    location: 'Rosario',
  },
  {
    quote: 'Encontré muchísimo contenido que puedo adaptar para mis clases.',
    author: 'Marcelo G.',
    location: 'Buenos Aires',
  },
  {
    quote: 'Pasé de mirar tutoriales sueltos a tener una guía para avanzar.',
    author: 'Lucas P.',
    location: 'Mendoza',
  },
  {
    quote:
      'Me dio ideas concretas para empezar a aplicar la Electrónica en proyectos.',
    author: 'Fernando S.',
    location: 'La Plata',
  },
]

export const TESTIMONIALS_NOTE =
  'Reemplazar estos testimonios de maquetación por testimonios reales antes de publicar.'

/* 6. FAQ */
export const faqs = [
  {
    q: '¿Es físico o digital?',
    a: 'Es material digital y recibís el acceso después de confirmar tu compra.',
  },
  {
    q: '¿Necesito experiencia previa?',
    a: 'No. Podés empezar desde los fundamentos y avanzar progresivamente.',
  },
  {
    q: '¿Sirve si ya sé Electrónica?',
    a: 'Sí. Podés utilizar los tomos de circuitos, proyectos, reparación y diagnóstico para reforzar y ampliar conocimientos.',
  },
  {
    q: '¿Sirve para docentes?',
    a: 'Sí. Podés utilizar el contenido como material de consulta y apoyo para preparar tus clases.',
  },
  {
    q: '¿Es solamente para emprendedores?',
    a: 'No. También está pensado para principiantes, aficionados, técnicos, profesionales y docentes.',
  },
  {
    q: '¿Es un pago único o una suscripción?',
    a: 'Es un pago único de $19.990 ARS por la oferta presentada.',
  },
  {
    q: '¿Recibo los 5 bonos inmediatamente?',
    a: 'Sí. Los 5 bonos forman parte del Mega Pack.',
  },
  {
    q: '¿Puedo estudiar a mi ritmo?',
    a: 'Sí. Al ser material digital, podés organizar el aprendizaje según tus tiempos.',
  },
  {
    q: '¿Necesito herramientas o componentes?',
    a: 'Para estudiar gran parte del contenido, no. Algunos proyectos prácticos pueden requerir componentes o herramientas específicas.',
  },
  {
    q: '¿Qué pasa si no estoy conforme?',
    a: 'Tenés 7 días de garantía para solicitar la devolución según las condiciones de la oferta.',
  },
]

/* POP-UP DE COMPRAS RECIENTES */
export const recentBuyers = [
  { name: 'Martín G.', city: 'Córdoba', minutes: 3 },
  { name: 'Lucía F.', city: 'Rosario', minutes: 7 },
  { name: 'Pablo S.', city: 'Buenos Aires', minutes: 11 },
  { name: 'Andrés M.', city: 'Mendoza', minutes: 14 },
  { name: 'Sofía L.', city: 'La Plata', minutes: 18 },
  { name: 'Javier R.', city: 'Mar del Plata', minutes: 23 },
  { name: 'Nicolás B.', city: 'Salta', minutes: 27 },
  { name: 'Camila V.', city: 'Tucumán', minutes: 32 },
]
